<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ invalid, validate }"
    class="w-full"
  >
    <main class="flex justify-center items-center aproe-bg min-h-5/6">
      <xn-waiting :show="requestSending" />
      <div class="bg-white md:w-2/3 rounded-sm">
        <div class="bg-muted rounded-sm m-0.5 ">
          <h4 class="uppercase rounded-sm px-6 flex justify-between">
            <p>
              {{ job.metadata.file_name }} - material: {{ materialName }} -
              units: {{ unitName }} - Count: {{ job.parameters.times_cut }}
            </p>
          </h4>
          <div class="bg-white w-full p-1">
            <form
              class="bg-muted px-2 rounded-sm"
              @submit.prevent="submitManualEstimate"
            >
              <div
                v-if="job.mfg_reference"
                class="text-center"
              >
                <h1>Current manufacturing reference files:</h1>
                <p v-if="job.mfg_reference">
                  {{ job.mfg_reference }}
                </p>
              </div>
              <div v-else>
                <h3 class="text-center">
                  No current manufacturing reference files
                </h3>
              </div>

              <div class="sm:px-6 flex flex-wrap justify-evenly">
                <div class="w-full sm:w-5/12 m-2">
                  <AproeFileInput
                    :file-types="['.ord', '.ORD', '.omx', '.OMX']"
                    :required="false"
                    file-info="Machine File To Upload"
                    @new-file-added="handleNewMachineFile"
                  />
                </div>
                <div class="w-full sm:w-5/12 m-2">
                  <AproeFileInput
                    :file-types="pathedRouteFileTypes"
                    :required="false"
                    file-info="Pathed Route File To Upload"
                    @new-file-added="handleNewPathedRouteFile"
                  />
                </div>
              </div>
                
              <div class="sm:px-6 flex flex-wrap justify-evenly">
                <div
                  v-if="job.public_reference"
                  class="w-full sm:w-5/12 m-2"
                >
                  <p>Current pathed visual reference image:</p>
                  <img :src="job.public_reference">
                </div>
                <div class="w-full sm:w-5/12 m-2">
                  <AproeFileInput
                    :file-types="['.jpg', '.JPG', '.jpeg', '.JPEG']"
                    :required="false"
                    file-info="Pathed Visual Reference File To Upload"
                    @new-file-added="handleNewVisualReferenceFile"
                  />
                </div>
              </div>
              <xn-input
                v-model="job.quote_price"
                class="w-full text-dark p-4 mx-2"
                label="Quote Price"
                type="currency"
                :required="true"
              />
              <xn-input
                v-model="job.metadata.pricing.material"
                class="w-full text-dark p-4 mx-2"
                label="Price Breakdown -- Material"
                type="currency"
                :required="true"
              />              <xn-input
                v-model="job.metadata.pricing.services"
                class="w-full text-dark p-4 mx-2"
                label="Price Breakdown -- Services"
                type="currency"
                :required="true"
              />
              <!-- <xn-input
                v-model="job.operation_time"
                class="w-full text-dark p-4 mx-2"
                label="Operation Time (Minutes)"
                type="number"
                :required="true"
              /> -->
              <br>
              <p class="flex justify-end">
                <input
                  type="submit"
                  value="Submit Manual Estimate"
                  class="btn m-2"
                >
              </p>
            </form>
          </div>
        </div>
      </div>
    </main>
  </ValidationObserver>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
import XnInput from '../components/primitives/XnInput.vue'
import AproeFileInput from '../components/AproeFileInput.vue'
import XnWaiting from '../components/primitives/XnWaiting.vue'
import GeneralMixins from '../mixins/GeneralMixins.vue'

export default {
  name: 'ManualEstimate',
  components: { ValidationObserver, XnInput, XnWaiting, AproeFileInput },
  mixins: [GeneralMixins],
  props: {
    id: { type: String, default: null },
  },
  data () {
    return {
      job: this.blankJob(),
      materialOptions: [],
      requestSending: false,
    }
  },
  computed: {
    materialName () {
      const material = this.materialOptions.find(
        option => option.id === +this.job.material
      )
      return material ? material.name : ''
    },
    unitName () {
      return this.job.parameters.scale
        ? this.job.parameters.scale === 1
          ? 'in'
          : 'cm'
        : ''
    },
    pathedRouteFileTypes () {
      if (this.job.parameters.axis_5) {
        return ['.STP', '.stp', '.STEP', '.step']
      } else {
        return ['.dxf', '.DXF']
      }
    },
  },
  created () {
    this.getJobUpdate(this.id)
    this.getMaterialOptions()
  },
  methods: {
    submitManualEstimate () {
      this.requestSending = true
      const formData = new FormData()
      formData.append('quote_price', this.job.quote_price)
      formData.append('material_price', this.job.metadata.pricing.material)
      formData.append('services_price', this.job.metadata.pricing.services)
      formData.append('operation_time', this.job.operation_time)

      if (this.job.pathed_route_file) {
        // formData.append('pathed_route_filename', this.job.pathed_route_filename)
        formData.append('pathed_route_file', this.job.pathed_route_file)
      }

      if (this.job.machine_file) {
        // // formData.append('machine_filename', this.job.machine_filename)
        formData.append('machine_file', this.job.machine_file)
      }

      if (this.job.visual_reference_file) {
        // formData.append('visual_reference_filename', this.job.visual_reference_filename)
        formData.append('visual_reference_file', this.job.visual_reference_file)
      }


      this.$api.Job.postManualEstimate(this.id, formData)
        .then(res => {
          if (res.status === 200) {
            this.$swal(`Price successfully set to ${this.toCurrency(res.data.price)}.`)
            this.getJobUpdate()
          } else {
            throw new Error('Error: ' + res.message)
          }
        })
        .catch(err => this.$swal(err.message))
        .finally(() => (this.requestSending = false))
    },
    centsToDollars (cents) {
      return (cents / 100).toLocaleString()
    },
    blankJob () {
      return {
        file: null,
        filename: undefined,
        material: undefined,
        operation_time: 0,
        parameters: {
          scale: 1,
          times_cut: 1,
          taper_compensation: false,
          axis_5: false,
          material: undefined,
        },
        metadata: {
          pricing: {}
        },
      }
    },
    parseTimeDelta (timeDelta) {
      /* take in a time delta string '12:34:56' and return an int of minutes */
      const [hours, minutes, seconds] = timeDelta.split(':')
      return hours * 60 + +minutes + Math.round(seconds / 60)
    },
    getJobUpdate () {
      this.$api.Job.getJobUpdate(this.id)
        .then(res => {
          if (res.status === 200) {
            const data = res.data
            if (!data.metadata.pricing) {
              data.metadata.pricing = {}
            }
            if (!data.metadata.pricing.material) {
              data.metadata.pricing.material = 0
            }
            if (!data.metadata.pricing.services) {
              data.metadata.pricing.services = 0
            }
            data.operation_time = this.parseTimeDelta(data.operation_time)
            this.job = data
          }
        })
        .catch(err => {
          this.$swal(err.message)
        })
    },
    getMaterialOptions () {
      this.$api.Materials.getMaterials()
        .then(res => {
          if (res.status === 200) {
            this.materialOptions = res.data.materials
          } else {
            throw new Error('Error: ', +res.message)
          }
        })
        .catch(err => {
          self.$swal(err.message)
        })
    },
    handleNewPathedRouteFile (file) {
      // this.job.pathed_route_filename = file.name
      this.job.pathed_route_file = file
    },
    handleNewMachineFile (file) {
      // this.job.machine_filename = file.name
      this.job.machine_file = file
    },
    handleNewVisualReferenceFile (file) {
      // this.job.visual_reference_filename = file.name
      this.job.visual_reference_file = file
    }
  },
}
</script>
<style>
.aproe-bg {
  background: url('../assets/aproe-quote-engine-bg-opt.jpg') center top
    no-repeat #525252 !important;
  background-size: cover !important;
}
</style>
